import { c } from '../../utils/tailwind-merge';
import { Chip } from '../Chip/Chip';
import { ChipListProps } from './types';

const baseClasses =
  'relative flex w-full flex-row gap-x-1 items-start md:flex-row md:gap-x-1';

export const ChipList = ({
  items,
  link,
  onClick,
  className,
}: ChipListProps) => {
  const chipList = (
    <>
      {items.map((item) => (
        <Chip
          key={item}
          label={item}
          type="button"
          link={link}
          className={className}
          onClick={onClick}
        />
      ))}
    </>
  );

  return <div className={c(baseClasses, className || '')}>{chipList}</div>;
};
